// 全局 Toast 服务
export default defineNuxtPlugin(() => {
  // 创建一个全局 Toast 服务
  const toast = {
    // 显示 Toast 消息
    show(message: string, type: 'success' | 'error' | 'warning' = 'error', duration: number = 3000) {
      // 使用自定义事件触发 Toast 显示
      window.dispatchEvent(new CustomEvent('show-toast', {
        detail: {
          message,
          type,
          duration
        }
      }));
    },
    
    // 显示成功消息
    success(message: string, duration: number = 3000) {
      this.show(message, 'success', duration);
    },
    
    // 显示错误消息
    error(message: string, duration: number = 3000) {
      this.show(message, 'error', duration);
    },
    
    // 显示警告消息
    warning(message: string, duration: number = 3000) {
      this.show(message, 'warning', duration);
    }
  };
  
  // 将 toast 服务注入到应用中
  return {
    provide: {
      toast
    }
  };
}); 